import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var HeartIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M21.5 3.9c-2.5-2.5-6.6-2.5-9.2 0l-.3.4-.4-.4C9.1 1.4 5 1.4 2.4 3.9A6.42 6.42 0 00.5 8.5c0 1.7.7 3.4 1.9 4.6l8.9 8.9c.2.2.5.3.7.3.2 0 .5-.1.7-.3l8.9-8.9c2.5-2.6 2.5-6.7-.1-9.2zm-1.3 7.8L12 19.9l-8.2-8.2c-.9-.9-1.3-2-1.3-3.3 0-1.2.5-2.3 1.3-3.1C4.7 4.5 5.9 4 7 4c1.2 0 2.3.4 3.2 1.3l1.1 1.1c.2.2.5.3.7.3.3 0 .5-.1.7-.3l1-1c1.8-1.7 4.7-1.7 6.4 0 1.8 1.7 1.8 4.5.1 6.3z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
HeartIcon.isCarinaIcon = true;
export default HeartIcon;
